<template>
  <div>
    <v-layout row wrap align-center justify-center class="mt-3">
      <v-flex xs12 sm6 md5 lg5>
        <v-hover>
          <v-card
            class="text-xs-center ma-3"
            slot-scope="{ hover }"
            :class="`elevation-${hover ? 12 : 2}`"
          >
            <v-card-title>
             <span class="headline font-weight-bold">How does this solution stand out?</span> 
             
            </v-card-title>
            <v-card-text>
              <v-form class="px-3" ref="form">
                <!-- <span v-for="(customerproblemdetail, index) in customerproblemdetails" :key="index"> -->
                  <!-- <v-layout row wrap>  -->

                

                 <v-textarea
                  outline   
                  :rules="textInputRules"
                  :label="uniquesellingpropositionprimaryLabelText"
                  v-model="uniquesellingpropositionprimary"
                  
                >
                 </v-textarea> 

<!-- 
                <v-textarea outline class="mt-3"
                :label="metricsolutionLabelText" 
                v-model="metrictitle" :hint="metricsolutionHintText" 
                :rules="textInputRules"></v-textarea>

                <v-textarea outline
                :label="metricscaleLabelText" 
                v-model="metrictitle2" :hint="metricscaleHintText" 
                ></v-textarea> -->

 


  
  
<!-- <v-layout
      row
      wrap
      style="width: 40px"
      
    > -->

 

<!-- </v-layout> -->
 

            
                
                <!-- <v-tooltip bottom v-if="customerproblemdetail.componentid && customerproblemdetail.tooltip">
      <template v-slot:activator="{ on }">
                            <v-btn flat icon color="grey" v-on="on">
              <v-icon>help</v-icon>
            </v-btn>
             </template>
      <span>Tooltip</span>
    </v-tooltip> --> 
                  <!-- </v-layout> -->
                <!-- :prepend-icon="customerproblemdetail.prependicon" -->
                <!-- </span> -->
                <!-- <v-text-field
                  outline
                  v-model="title"
                  v-if="includeWhyTheProblemIsImportantToTheCustomer"
                  label="Why is the problem important to the customer?"
                  prepend-icon="folder"
                ></v-text-field> -->

                

                

                <v-spacer></v-spacer>
                <v-btn flat @click="$router.go(-1)" class="mx-4 mt-3">Head back</v-btn>
                <!-- <v-btn @click="submit" flat color="primary" class="mx-2 mt-3" :loading="loading">Head to Growth Marketing</v-btn> -->
                <v-btn flat to="/bcgrowthmarkingdetails" color="primary" class="mx-2 mt-3" :loading="loading"><!--Head to Growth Marketing --> Go Next</v-btn> 
              </v-form>
            </v-card-text>
          </v-card>
        </v-hover>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import db from '../fb'
import gvars from '../globalvariables'

export default {
  name: "BC foundation elements - Section 01",
  components: {},
  data() {
    return { 
      doWe: false,
      uniquesellingpropositionprimary: 'Employment of the Eisenhower method to task management with an emphasis on the user experience',
      uniquesellingpropositionprimaryLabelText: 'What is the unique selling proposition of this solution.',
      metrictitle: 'Cost to time saved ratio',
      metricsolutionLabelText: 'Provide one metric for the solution.',
      metricsolutionHintText: 'Provide one metric which will help track the impact of the solution on the customer problem.',
      metrictitle2: 'Server cost per user per month',
      metricscaleLabelText: 'Provide one metric to handle scale',
      metricscaleHintText: 'Provide one metric which will help measure the aspects of growth of the product, in terms of scale.',
 
        
      textInputRules: [
        v => !!v || 'This field is required',
        v => v.length >= 3 || 'Minimum length is 3 characters'
      ],
      selectInputRules: [
        v => !!v || 'This field is required'
      ],
      loading: false
    }
  },
  methods: {
    submit(){
      //console.log(this.dropdownList[1].isEnabled)
      
 if(this.$refs.form.validate()) {
        //console.log("Attempt to submit")
        this.loading = true;
        //  const project = {

        //   projecttitle: this.projecttitle,
        //   customerproblemdescription: this.customerproblemdescription,
        //   whythisproblem: this.whythisproblem,
        //   targetagerange: this.targetagerange,
        //   problemdomain: this.problemdomain,
        //   additionaldetailforproblem: this.additionaldetailforproblem,
        //   locationofuser: this.locationofuser,
        //   locationofsolutionusage: this.locationofsolutionusage
        // }

        // // db.collection('projects').add(project).then(function(docRef) {
        // //         console.log("Document written with ID: ", docRef.id);
        // //         this.loading = false;


        // //     })
        // //     .catch(function(error) {
        // //         console.error("Error adding document: ", error);
        // //     });

        //    db.collection('projects').add(project).then(() => {
        //   //console.log("added to db!", docRef.id)
        //   this.loading = false;
        //   this.$router.push('addstoriespainpoints')
        // })
      




            const businessdetail = {
          uniquesellingpropositionprimary: this.uniquesellingpropositionprimary 

            }
 

            db.collection('projects').doc(this.getProjectID()).update(businessdetail).then(() => {
                    //console.log("added to db!", this.getProjectID())
                    this.loading = false;
                    this.dialog = false;
                    this.$router.push('bcgrowthmarkingdetails')
                    ///this.$emit('firstprefdetailsconfirmed')
                });



      const metric = {
                metrictitle: this.metrictitle,
                metriccategory: 'Solution'
            }
 

            //Yx3r6dHUeFFdGvY6Acvy

           db.collection('projects').doc(this.getProjectID()).collection('metrics').add(metric).then(() => {
          //console.log("added to db!", docRef.id)
          //nameofthesolution = '';
          //briefdescriptionofthesolution = '';
          this.loading = false;
          this.dialog = false;
          //this.$emit('projectadded')
       });

       const metric2 = {
                metrictitle: this.metrictitle2,
                metriccategory: 'Scale'
            }
 

            //Yx3r6dHUeFFdGvY6Acvy

           db.collection('projects').doc(this.getProjectID()).collection('metrics').add(metric2).then(() => {
          //console.log("added to db!", docRef.id)
          //nameofthesolution = '';
          //briefdescriptionofthesolution = '';
          this.loading = false;
          this.dialog = false;
          //this.$emit('projec

    });


        }

    },
    getProjectID(){
      return gvars.PROJECTID;
    }
    
  },
  computed: {
    remainingDetailsToBeAdded(){
      return this.dropdownList.filter(dropdownListElement => {
        return dropdownListElement.isEnabled == false
      })
    },
    doWeHaveAdditionalDetailsToAdd(){
      this.doWe = this.dropdownList.filter(dropdownListElement => {
        return dropdownListElement.isEnabled == false
      })
  
      //console.log(this.doWe) 
      if (this.doWe.length == 0)
      {
        return false
      }else{
        return true
      }

      //this.doWe = doWe

      //return this.doWe
    }
  }
};
</script>

<style>
</style>
